"use client";

import React from "react";
import { MessageIcon } from "staysure-component-library";

import { Agent } from "@/components/molecules/cta-button/cta-buttons";
import useMediaQuery from "@/hooks/use-media-query/use-media-query-enhanced";
import { showMessenger } from "@/utils/cxone.utils";

interface FloatingChatButtonProps {
  chatButtonLabelMobile?: string;
  chatButtonLabelDesktop?: string;
  show?: boolean;
}

function FloatingChatButton({
  chatButtonLabelMobile,
  chatButtonLabelDesktop,
  show = false,
}: Readonly<FloatingChatButtonProps>) {
  const [isMobile] = useMediaQuery("(max-width: 599px)");

  if (!show) return null;

  return (
    <div>
      <Agent
        label={
          isMobile
            ? chatButtonLabelMobile ?? "Chat with us"
            : chatButtonLabelDesktop ?? "Not sure? Chat with us "
        }
        hierarchy="primary"
        className="w-[150px] md:w-[300px] md:h-[56px] h-[36px] md:px-spacing-l px-spacing-s md:py-spacing-s py-spacing-xxs font-semibold md:text-xs text-3xs md:leading-custom-size-xs leading-custom-size-md rounded-t-2xl text-white bg-text-title -rotate-90 border-t border-x border-border-onlight fixed right-0 top-1/2 -translate-y-1/2 md:translate-x-[122px] translate-x-[57px]
               z-[52]"
        rightIcon={
          <span style={{ marginLeft: "4px" }}>
            <MessageIcon stroke="white" fill="white" />
          </span>
        }
        isRightIcon
        semanticColor="Dark Background"
        onClick={() => {
          if (typeof window !== "undefined") {
            showMessenger();
          }
        }}
      />
    </div>
  );
}

export default FloatingChatButton;
